const renewal_period_statuses = [
  {
    label: "30 Days",
    value: "30",
    code: 1,
  },
  {
    label: "60 Days",
    value: "60",
    code: 2,
  },
  {
    label: "90 Days",
    value: "90",
    code: 3,
  },
];

export default renewal_period_statuses;
